export default __webpack_public_path__ + "static/Cart-HelixMaglock-53c2e93b96961e536358e4a1636895eb.jpg";